export const GUEST_LIMIT = 3;

export function getGuestCount() {
  const data = JSON.parse(localStorage.getItem('guest_usage') || '{}');
  const today = new Date().toDateString();
  if (data.date !== today) return 0;
  return data.count || 0;
}

export function incrementGuestCount() {
  const today = new Date().toDateString();
  const count = getGuestCount() + 1;
  localStorage.setItem('guest_usage', JSON.stringify({ date: today, count }));
  return count;
}